import styled from 'styled-components';

export const FileNameArea = styled.div`
  padding: 6px;
  margin-right: 6px;
`;
